import { Routes, Route } from "react-router-dom";

import Users from "./Users";
import UserEdit from "./UserEdit";
import UserDetails from "./UserDetails";

const index = () => {
	return (
		<Routes>
			<Route index element={<Users />} />
			<Route path='/:id/edit' element={<UserEdit />} />
			<Route path='/:id/details' element={<UserDetails />} />
		</Routes>
	);
};

export default index;
